import { render, staticRenderFns } from "./FaqTable.vue?vue&type=template&id=46f4a4fc&"
import script from "./FaqTable.vue?vue&type=script&lang=js&"
export * from "./FaqTable.vue?vue&type=script&lang=js&"
import style0 from "./FaqTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports